"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toPremiumFeature = exports.PremiumFeature = void 0;
var PremiumFeature;
(function (PremiumFeature) {
    PremiumFeature["CHATBOT"] = "Gleblu Chatbot";
    PremiumFeature["AUTOMATIC_RESERVATION"] = "Automatic Reservation";
})(PremiumFeature || (exports.PremiumFeature = PremiumFeature = {}));
const premiumFeatureValueMap = new Map(Object.entries(PremiumFeature).map(([key, value]) => [value, key]));
const toPremiumFeature = (feature) => {
    const key = premiumFeatureValueMap.get(feature);
    if (!key)
        throw new Error(`${feature} is not a value of PremiumFeature`);
    return PremiumFeature[key];
};
exports.toPremiumFeature = toPremiumFeature;
//# sourceMappingURL=PremiumFeature.js.map